export default "__VITE_ASSET__Bzf_9fn5__"